import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import { BgQuatro } from '../bg-clip-paths/bg-quatro/bg-quatro';
import profilePicture from "./bg-profile-picture.scss?inline";
import {unsafeHTML} from "lit/directives/unsafe-html.js";

const shoelaceElementFactory = (tagName: string) => {
  customElements.define(tagName, BgQuatro);
};

export interface BgProfilePictureInterface {
  name: string, 
  title: string, 
  color: string
}

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */

@customElement('bg-profile-picture')
export class BgProfilePicture extends LitElement {

  constructor(args:BgProfilePictureInterface) {
    super();
    if(!args) {
      return
    };
    this.title = args.title;
    this.color = args.color
  }

  @property()
  docsHint = '';
  
  @property({ type: String })
  name = "";

  @property({ type: String })
  title = "";

  @property({ type: String })
  color = "";

  render() {
    return html`
    <div class="profile-picture-container">
      <bg-quatro color=${this.color} size="200">
        <slot name="image"></slot>
      </bg-quatro>
      <h2>${this.name}</h2>
      ${unsafeHTML(this.title)}
    </div>
    `
  }
  
  static styles = [
    unsafeCSS(profilePicture)
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'bg-profile-picture': BgProfilePicture
  }
}
